import { useLanguage } from '../../context/LanguageContext';

function InputTile({
  maxLength = 30,
  required = false,
  disable = false,
  type = 'game',
  name = 'playerAnswer',
  onChange = () => {},
  value = '',
}) {
  const { t } = useLanguage();

  const baseClasses = 'focus:outline-none dark:bg-background-dark';
  const variants = {
    game: 'w-28 sm:w-56 md:w-64',
    survey: 'p-4 py-3 mt-4 border border-gray rounded-2xl w-full',
  };

  const patterns = {
    game: "^[A-Za-z0-9À-ÿ.,!'\\-\\? ]+$",
    survey: '^[A-Za-z0-9À-ÿ:;–—“”’\\-\\? .,!\'\\(\\)"\\@\\=\\%\\&\\+\\=\\-]+$',
  };

  return (
    !disable && (
      <input
        id={name}
        name={name}
        className={`${baseClasses} ${variants[type]}`}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={t('yourAnswerHere')}
        maxLength={maxLength}
        pattern={patterns[type] ?? patterns.survey}
        required={required}
        disabled={disable}
      />
    )
  );
}

export default InputTile;
